import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageTemplate } from "src/layout/components/PageTemplate";
import { SaleOrdersNewForm } from "../components/SaleOrdersNewForm";
import { AppDispatch, RootState } from "src/store";
import {
  getCustomers,
  reset as resetCustomers,
} from "src/features/customers/redux/CustomersSlice";
import {
  getorders,
  reset as resetOrders,
} from "src/features/orders/redux/orderSlice";
import {
  getWarehouses,
  reset as resetWarehouses,
} from "src/features/warehouses/redux/WarehouseSlice";
import {
  getProducts,
  reset as resetProducts,
} from "src/features/products/redux/ProductsSlice";
import Loading from "src/components/Loading";

const SaleOrdersNew = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { enqueueSnackbar } = useSnackbar();
  const [page, setPage] = useState(1);

  const {
    customers,
    isError: isCustomersError,
    isSuccess: isCustomersSuccess,
    message: customersMessage,
    isLoading: isCustomersLoading,
  } = useSelector((state: RootState) => state.customers);

  const {
    orders,
    isError: isOrdersError,
    isSuccess: isOrdersSuccess,
    message: ordersMessage,
    isLoading: isOrdersLoading,
  } = useSelector((state: RootState) => state.orders);

  const {
    Warehouses,
    isError: isWarehousesError,
    isSuccess: isWarehousesSuccess,
    message: warehousesMessage,
    isLoading: isWarehousesLoading,
  } = useSelector((state: RootState) => state.warehouse);

  const {
    products,
    isError: isProductsError,
    isSuccess: isProductsSuccess,
    message: productsMessage,
    isLoading: isProductsLoading,
  } = useSelector((state: RootState) => state.products);

  useEffect(() => {
    if (isCustomersError) {
      enqueueSnackbar(customersMessage, { variant: "error" });
    }
    return () => {
      dispatch(resetCustomers());
    };
  }, [isCustomersError, isCustomersSuccess, isCustomersLoading]);

  useEffect(() => {
    if (isOrdersError) {
      enqueueSnackbar(ordersMessage, { variant: "error" });
    }
    return () => {
      dispatch(resetOrders());
    };
  }, [isOrdersError, isOrdersSuccess, isOrdersLoading]);

  useEffect(() => {
    if (isWarehousesError) {
      enqueueSnackbar(warehousesMessage, { variant: "error" });
    }
    return () => {
      dispatch(resetWarehouses());
    };
  }, [isWarehousesError, isWarehousesSuccess, isWarehousesLoading]);

  useEffect(() => {
    if (isProductsError) {
      enqueueSnackbar(productsMessage, { variant: "error" });
    }
    return () => {
      dispatch(resetProducts());
    };
  }, [isProductsError, isProductsSuccess, isProductsLoading]);

  useEffect(() => {
    dispatch(
      getCustomers({
        page: page,
        limit: 100,
      })
    );
    dispatch(
      getorders({
        page: page,
        limit: 100,
      })
    );
    dispatch(
      getWarehouses({
        page: page,
        limit: 100,
      })
    );
    dispatch(
      getProducts({
        page: page,
        limit: 100,
      })
    );
  }, []);

  return (
    <PageTemplate
      isTransparent
      crumbs={[
        {
          label: "saleOrders",
          href: "/saleOrders/saleOrders-list",
          depth: -1,
        },
        {
          label: "New Sale Order",
        },
      ]}
    >
      {isCustomersLoading ||
      isOrdersLoading ||
      isWarehousesLoading ||
      isProductsLoading ? (
        <Loading />
      ) : (
        <SaleOrdersNewForm
          customersData={customers}
          ordersData={orders}
          warehousesData={Warehouses}
          productsData={products}
        />
      )}
    </PageTemplate>
  );
};

export default SaleOrdersNew;
